import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Generated class for the RmtWarningCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-notify-card',
  templateUrl: 'rmt-notify-card.html'
})
export class RmtNotifyCardComponent {

  @Input() title: string;
  @Input() buttonTitle: string;
  @Input() dismiss: boolean = false;
  @Input() padding: boolean = false;
  @Input() icon: string;
  @Input() color: string;
  @Input() dismissed: boolean = false;
  @Output() buttonAction = new EventEmitter();
  @Output() dismissAction = new EventEmitter<any>();

  constructor() {
  }

  onClick() {
    this.buttonAction.emit();
  }

  onDismiss() {
    this.dismissed = true;
    this.dismissAction.emit();
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-notify-card/rmt-notify-card.ts